module.exports = __webpack_public_path__ + "static/media/mstile-310x310.ca883536.png";